/*!
 * oimo&coco. Franchise Referral Tracker
 * ----------------------------------------------------------------------
 * Shopify 管理画面 → オンラインストア → テーマ編集 → theme.liquid の
 * </head> 直前に以下を配置してください（PORTAL_BASE_URL は本番ドメインに差し替え）。
 *
 *   <script>
 *     window.OIMO_TRACKER = { portal: "https://order.nonii.co.jp" };
 *   </script>
 *   <script src="{{ 'oimo-coco-tracker.js' | asset_url }}" defer></script>
 *
 * あるいは本ファイルの内容をそのまま <script> タグ内にインラインで貼り付けても OK。
 * ---------------------------------------------------------------------- */
(function () {
  "use strict";

  var CONFIG = (window.OIMO_TRACKER || {});
  var PORTAL = CONFIG.portal || "https://order.nonii.co.jp";
  var COOKIE_NAME = "oimo_ref";
  var COOKIE_DAYS = 30;
  var STORE_ID_RE = /^[a-z0-9_-]{2,32}$/i;

  function getCookie(name) {
    var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]+)"));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function setCookie(name, value, days) {
    var exp = new Date();
    exp.setDate(exp.getDate() + days);
    document.cookie =
      name + "=" + encodeURIComponent(value) +
      "; expires=" + exp.toUTCString() +
      "; path=/; SameSite=Lax; Secure";
  }

  function sendClick(storeId) {
    try {
      var payload = JSON.stringify({
        store_id: storeId,
        landing: location.pathname,
      });
      var url = PORTAL.replace(/\/$/, "") + "/api/track-click";
      if (navigator.sendBeacon) {
        var blob = new Blob([payload], { type: "application/json" });
        navigator.sendBeacon(url, blob);
      } else {
        fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: payload,
          keepalive: true,
          mode: "cors",
        }).catch(function () {});
      }
    } catch (_) {}
  }

  function injectCartAttribute(storeId) {
    try {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { store_id: storeId } }),
      }).catch(function () {});
    } catch (_) {}
  }

  try {
    var params = new URLSearchParams(window.location.search);
    var ref = params.get("ref");

    if (ref && STORE_ID_RE.test(ref)) {
      setCookie(COOKIE_NAME, ref, COOKIE_DAYS);
      sendClick(ref);
    }

    var cookie = getCookie(COOKIE_NAME);
    if (cookie && STORE_ID_RE.test(cookie)) {
      injectCartAttribute(cookie);
    }
  } catch (_) {
    // トラッキングの失敗はユーザー体験に影響させない
  }
})();
